<!--
*****************************************************************************
*File : Drawer.vue
*Module : Dashboard Frontend
*Purpose : Displays all the navigations titles.
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
-->

<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs" 
  >
  <template v-slot:img="props">
    <v-img
      :gradient="`to bottom, ${barColor}`"
      v-bind="props"
    />
  </template>

  <v-list-item class="title">
    <v-list-item-icon>
      <img width="56" height="56" src="@/assets/icons/logo.svg"  />
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>MVIS</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

  <v-list
    expand
    nav
  >  
    <div/>

    <template v-for="(item, i) in computedItems">
      <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
      >  
      </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
      />
    </template>

    <div />
      
  </v-list>

  <template v-slot:append>
    <div class="pa-2">
      <v-list-item>
        <v-list-item-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <a href="https://www.l2mrail.com" target="_blank">
            <img id="l2mLogo" align="center" ref="l2mLogo" width="140" src="../../../../assets/images/L2M.png"/>
          </a>
        </v-list-item-content>
      </v-list-item>
    </div>
  </template>

  </v-navigation-drawer>
  
</template>

<script>
  // Utilities

  import {
    mapState
  } from 'vuex'

  import { router } from '@/router';

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      items: [],
      onlyUsers: [
        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/dashboard'
        },
        {
          group: '/report',
          icon: 'mdi-file-document',
          title: 'Reports',
          children: [
            {
              title: 'Consolidated Report',
              to: 'train-information'
            },
            // {
            //   title: 'DFIS ID',
            //   to: 'dfis-id-report'
            // }, 
          ]
        },
    ],

      onlyAdmin: [
        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/dashboard'
        },
        {
          group: '/report',
          icon: 'mdi-file-document',
          title: 'Reports',
          children: [
            {
              title: 'Consolidated Report',
              to: 'train-information'
            },
            // {
            //   title: 'DFIS ID',
            //   to: 'dfis-id-report'
            // }, 
          ]
        },
	//{
        //  icon: 'mdi-chart-box',
        //  title: 'Performance',
        //  to: '/yard'
        //},
	// {
  //         group: '/control-panel',
  //         icon: 'mdi-camera-control',
  //         title: 'Control Panel',
	//   children: [
	//     {
  //             title: 'Live View', //title in the nav bar
  //             to: 'dpu-live-view', //'to' or path the page
  //           }
  //         ]
  //       },
        {
          icon: 'mdi-account-multiple',
          title: 'Users',
          to: '/userprofile'
        },        
        {
          icon: 'mdi-account',
          title: 'User Registration',
          to: '/register'
        },
       
      ],

      onlySSE: [

        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/dashboard'
        },
        {
          group: '/report',
          icon: 'mdi-file-document',
          title: 'Reports',
          children: [
            {
              title: 'Consolidated Report',
              to: 'train-information'
            },
            // {
            //   title: 'DFIS ID',
            //   to: 'dfis-id-report'
            // }, 
          ]
        },
      ],

      onlySupervisor: [

        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/dashboard'
        },
        {
          group: '/report',
          icon: 'mdi-file-document',
          title: 'Reports',
          children: [
            {
              title: 'Consolidated Report',
              to: 'train-information'
            },
            // {
            //   title: 'DFIS ID',
            //   to: 'dfis-id-report'
            // }, 
          ]
        },	      
      ],

      onlyManager: [

        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/dashboardmgr'
        },
        {
          group: '/report',
          icon: 'mdi-file-document',
          title: 'Reports',
          children: [
            {
              title: 'Consolidated Report',
              to: 'train-information'
            },
            // {
            //   title: 'DFIS ID',
            //   to: 'dfis-id-report'
            // }, 
          ]
        },	      
      ],

      onlyExecutives: [

        {
          icon: 'mdi-view-dashboard',
          title: 'Dashboard',
          to: '/dashboard'
        },
        {
          group: '/report',
          icon: 'mdi-file-document',
          title: 'Reports',
          children: [
            {
              title: 'Consolidated Report',
              to: 'train-information'
            },
            // {
            //   title: 'DFIS ID',
            //   to: 'dfis-id-report'
            // }, 
          ]
        },	      
      ]

    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        }
      },
      computedItems () {
        const currentUser = router.app.$store.state.logUser;
        for ( var index=0; index < this.onlyAdmin.length; index++ ) {
          
          if((this.$store.state.logUserAdmin.includes("Admin")) == true) {
            this.items.push(this.onlyAdmin)
            return this.items[0].map(this.mapItem) 
          }
          else if((this.$store.state.logUserAdmin.includes("Corporate Office")) == true) {
            this.items.push(this.onlySSE)
            return this.items[0].map(this.mapItem)
          }
          else if((this.$store.state.logUserAdmin.includes("Supervisor")) == true) {
            this.items.push(this.onlySupervisor)
            return this.items[0].map(this.mapItem)
          }
          else if((this.$store.state.logUserAdmin.includes("Manager")) == true) {
            this.items.push(this.onlyManager)
            return this.items[0].map(this.mapItem)
          }
          else if((this.$store.state.logUserAdmin.includes("R&D Team")) == true) {
            this.items.push(this.onlyExecutives)
            return this.items[0].map(this.mapItem)
          }
          else { 
            this.items.push(this.onlyUsers)
            return this.items[0].map(this.mapItem) 
          }  
        }                     
      },
      profile () {
        return {
          avatar: false,
          group: '',
          title: this.$t('avatar'),
          children: [
            {
              href: '',
              title: this.$t('my-profile')
            },
            {
              to: '',
              title: this.$t('edit-profile')
            },
            {
              to: '',
              title: this.$t('settings')
            }
          ]
        }
      }
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      }
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: item.title
        }
      },
    }
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>

<style lang="scss">
  .l2m-logo {
    position:fixed;
    right: 0px;
    bottom: 0px; 
  }

  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child) {
    padding-right: 33px ;
  }
</style>
